import React from 'react'

import Routing from 'routing'
import { InternationalizationProvider } from 'providers/intl'
import { AuthProvider } from 'providers/auth'
import { ProfileProvider } from 'providers/profile'
import { CountriesProvider } from 'providers/countries'
import { SocketProvider } from './providers/socket'
import { MySiteProvider } from './providers/mySiteProvider'
import { HabitatProvider } from './providers/HabitatContext'

const App = () => {
  return (
    <InternationalizationProvider>
      <CountriesProvider>
        <AuthProvider>
          <ProfileProvider>
            <SocketProvider>
              <MySiteProvider>
                <HabitatProvider>
                  <Routing />
                </HabitatProvider>
              </MySiteProvider>
            </SocketProvider>
          </ProfileProvider>
        </AuthProvider>
      </CountriesProvider>
    </InternationalizationProvider>
  )
}
export default App
